module.exports = __webpack_public_path__ + "static/aleksandra_after-f2e76d2c138bb997864bae67cd7de6c9.png";